/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box, Button } from "@nordcloud/gnui";
import { StyledLink } from "~/components";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { ApplicationTable } from "./components/ApplicationTable";

export function ApplicationsPage() {
  const breadcrumbsLabels = [
    { label: "Dashboard", uri: "/" },
    { label: "Applications", uri: ROUTES.applications.index },
  ];

  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Applications"
            customBreadcrumbs={breadcrumbsLabels}
          >
            <StyledLink to={ROUTES.applications.create}>
              <Button icon="plus">Create Application</Button>
            </StyledLink>
          </BreadcrumbsBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <ApplicationTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
